import i18n from "@swa-ui/locale";
import {
  getNewUsernameFormFieldSchema,
  getSecurityQuestionsFormFieldSchema,
} from "@swa-ui/loyalty";
import { yup } from "@swa-ui/object";
import { getEmailFormFieldSchema, getPhoneFormFieldsSchema } from "@swa-ui/personal-info";

export const getMissingInformationFormSchema = (missingInformation) => {
  return yup.object().shape({
    ...(isMissing("EMAIL") && { email: getEmailFormFieldSchema().required() }),
    ...(isMissing("PHONE") && getPhoneFormFieldsSchema({ showPhoneType: true })),
    ...(isMissing("SECURITY_CHALLENGE") && getSecurityQuestionsFormFieldSchema()),
    ...(isMissing("USERNAME") && { username: getNewUsernameFormFieldSchema() }),
    termsAgree: yup
      .boolean()
      .oneOf([true], i18n("MissingInformationForm__TERMS_AGREE_REQUIRED"))
      .required(i18n("MissingInformationForm__TERMS_AGREE_REQUIRED")),
  });

  function isMissing(type) {
    return missingInformation?.some?.((value) => value === type);
  }
};
